import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { InviteFriendMutationKeys } from '../../../keys'
import {
	UpdateInviteFriendRequest,
	UpdateInviteFriendResponse,
} from '../../../type'
import { updateInviteFriend } from '../../services'

interface UpdateInviteFriendParams {
	payload: UpdateInviteFriendRequest
}

export default function useMutationUpdateInviteFriend(
	props?: UseBaseMutationOptions<
		UpdateInviteFriendResponse,
		UpdateInviteFriendParams
	>,
) {
	return useMutation({
		mutationKey: [InviteFriendMutationKeys.UpdateInviteFriend],
		mutationFn: (params) => updateInviteFriend(params.payload),
		...props,
	})
}
